const FormBuilder = () => import("Core/configuration/developer/views/FormBuilder");

// ROUTE OPTION - `pathToRegexpOptions: { strict: true }` makes trailing slashes fail to match path
export default {
    children: [
        {
            path: "configuration/form_builder/:form_id?",
            name: "settings_form_builder",
            component: FormBuilder,
            meta: {
                requiresAuth: true,
                title: "lang.form_builder",
                restrict_by_login_type: ["employee"],
                restrict_by_permission: ["configuration.read"],
            },
        },
    ],
};
